// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"56b15830","491":"e7f28e14","723":"9d09a180","855":"9e92a9cf"}[chunkId] + ".chunk.css";
};